import { styled } from 'stitches.config'

export const AllArticlesLinksRoot = styled('ul', {
  display: 'none',
})
